import { render, staticRenderFns } from "./newRenewal.vue?vue&type=template&id=baa43558&scoped=true"
import script from "./newRenewal.vue?vue&type=script&lang=js"
export * from "./newRenewal.vue?vue&type=script&lang=js"
import style0 from "./newRenewal.vue?vue&type=style&index=0&id=baa43558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa43558",
  null
  
)

export default component.exports